import { render } from "./ContractInformationReadonly.vue?vue&type=template&id=24d0677e&scoped=true&ts=true"
import script from "./ContractInformationReadonly.vue?vue&type=script&lang=ts"
export * from "./ContractInformationReadonly.vue?vue&type=script&lang=ts"

import "./ContractInformationReadonly.vue?vue&type=style&index=0&id=24d0677e&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d0677e"]])

export default __exports__